import React from 'react';
import './CaseCard.css';

const CaseCard = ({ caseItem }) => {
  return (
    <div className="case-card">
      <div className="case-card-head">
        <img
          className="case-card-avatar-img"
          src={caseItem.image}
          alt={caseItem.name}
        />
        <div>
          <div className="case-card-nome">{caseItem.name}</div>
          <div className="case-card-empresa">{caseItem.company}</div>
        </div>
      </div>
      <div className="case-card-stars">
        {'★'.repeat(caseItem.rating)}
      </div>
      <p className="case-card-quote">{caseItem.quote}</p>
    </div>
  );
};

export default CaseCard;
